"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import "swiper/css";

type Membership = {
  title?: string;
  image: string;
  link: string;
};

const memberships: Membership[] = [
  {
    title: "hanfdaemmung.at",
    image: "/assets/mitgliedschaften/hanfdaemmung-at.png",
    link:"https://www.hanfdaemmung.at/"
  },
  {
    title: "VOEH",
    image: "/assets/mitgliedschaften/logo-voeh.jpg",
    link:"https://www.hanfdaemmung.at/"
  },
  {
    title: "putzdrauf.at",
    image: "/assets/mitgliedschaften/logo-putzdrauf.jpg",
    link:"https://putzdrauf.at/"
  },
  
  {
    title: "ÖAP",
    image: "/assets/mitgliedschaften/logo-oeap.jpg",
    link:"https://www.hanfdaemmung.at/"
  },
];

export default function MembershipSlider() {



  return (
    <div className="w-full bg-white text-company-primary-color pb-16">
      <div className="bg-white text-company-primary-color pt-16">
      <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-3xl font-bold text-company-color-primary">Mitgliedschaften</h2>
      </div></div>
    <div className="w-full max-w-3xl mx-auto py-4 px-4">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={4}
        loop
        autoplay
        breakpoints={{
          0: {
            slidesPerView: 2, // for small screens (mobile)
          },
          768: {
            slidesPerView: 4, // for medium and larger screens
          },
        }}      
      >
        {memberships.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={item.image}
                alt={item.title || `Mitgliedschaft ${index + 1}`}
                className="w-full h-64 object-contain"
              />
              {item.title && (
                <div className="absolute bottom-0 w-full bg-company-color-secondary text-white text-center py-2">
                  {item.title}
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    </div>
  );
}
